module.exports = __webpack_public_path__ + "img/T4-A-xh_7.523c7211.png";